export class shoppingCart{
    _id:any;
    accountId:any;
    productId:any;
    requiredQuantity:any;
    plannedPurchasedate:any;
    status:any;
    adminId:any
}